/* eslint-disable dot-notation */
import WorkanoApiClient from "../api-client";

// Can't use node cache mechanism here because when requiring lib/CallApi.js
// this file will be merge with CallApi.js and the cache will be lost.
// So we have to store values in global scope.
global.workanoClients = global.workanoClients || {};
global.workanoClientId = global.workanoClientId || {};
global.workanoClientToken = global.workanoClientToken || {};
global.workanoRefreshToken = global.workanoRefreshToken || {};
global.workanoRefreshTenantId = global.workanoRefreshTenantId || {};
global.workanoRefreshDomainName = global.workanoRefreshDomainName || {};
global.workanoOnRefreshToken = global.workanoOnRefreshToken || {};
global.workanoOnRefreshTokenError = global.workanoOnRefreshTokenError || {};
global.workanoRefreshExpiration = global.workanoRefreshExpiration || {};
global.workanoRefreshBackend = global.workanoRefreshBackend || {};
global.workanoIsMobile = global.workanoIsMobile || {};
global.workanoRequestApiTimeout = global.workanoRequestApiTimeout || {};
global.workanoFetchOptions = global.workanoFetchOptions || {};
export const setApiClientId = (
    clientId: string,
    forServer: string | null | undefined = null
) => {
    global.workanoClientId[String(forServer)] = clientId;
};
export const setCurrentServer = (newServer: string) => {
    global.workanoCurrentServer = newServer;
};
export const setApiToken = (
    newToken: string | null | undefined,
    forServer: string | null | undefined = null
) => {
    global.workanoClientToken[String(forServer)] = newToken;
};
export const setRefreshToken = (
    newRefreshToken: string | null | undefined,
    forServer: string | null | undefined = null
) => {
    global.workanoRefreshToken[String(forServer)] = newRefreshToken;
};
export const setRefreshTenantId = (
    refreshTenantId: string | null | undefined,
    forServer: string | null | undefined = null
) => {
    console.warn(
        "Use of `setRefreshTenantId` is deprecated, please use `setRefreshDomainName` instead"
    );
    global.workanoRefreshTenantId[String(forServer)] = refreshTenantId;
};
export const setRefreshDomainName = (
    refreshDomainName: string | null | undefined,
    forServer: string | null | undefined = null
) => {
    global.workanoRefreshDomainName[String(forServer)] = refreshDomainName;
};
export const setOnRefreshToken = (
    onRefreshToken: (...args: Array<any>) => any,
    forServer: string | null | undefined = null
) => {
    global.workanoOnRefreshToken[String(forServer)] = onRefreshToken;
};
export const setOnRefreshTokenError = (
    callback: (...args: Array<any>) => any,
    forServer: string | null | undefined = null
) => {
    global.workanoOnRefreshTokenError[String(forServer)] = callback;
};
export const setRefreshExpiration = (
    refreshExpiration: number,
    forServer: string | null | undefined = null
) => {
    global.workanoRefreshExpiration[String(forServer)] = refreshExpiration;
};
export const setRefreshBackend = (
    refreshBackend: number,
    forServer: string | null | undefined = null
) => {
    global.workanoRefreshBackend[String(forServer)] = refreshBackend;
};
export const setIsMobile = (
    isMobile: boolean,
    forServer: string | null | undefined = null
) => {
    global.workanoIsMobile[String(forServer)] = isMobile;
};
export const setRequestTimeout = (
    requestTimeout: number,
    forServer: string | null | undefined = null
) => {
    global.workanoRequestApiTimeout[String(forServer)] = requestTimeout;
};
export const setFetchOptions = (
    fetchOptions: Record<string, any>,
    forServer: string | null | undefined = null
) => {
    global.workanoFetchOptions[String(forServer)] = fetchOptions;
};
export const getFetchOptions = (forServer: string | null | undefined = null) =>
    (forServer
        ? global.workanoFetchOptions[forServer]
        : global.workanoFetchOptions.null) || global.workanoFetchOptions.null;

const fillClient = (apiClient: WorkanoApiClient) => {
    const { server, token, clientId } = apiClient.client;
    const tenantId =
        global.workanoRefreshTenantId[server] ||
        global.workanoRefreshTenantId.null ||
        apiClient.refreshTenantId;
    const requestTimeout =
        global.workanoRequestApiTimeout[server] ||
        global.workanoRequestApiTimeout.null;
    //  try with null server when dealing with non-related server info
    apiClient.setToken(
        global.workanoClientToken[server] ||
            global.workanoClientToken.null ||
            token
    );
    apiClient.setClientId(
        global.workanoClientId[server] ||
            global.workanoClientId.null ||
            clientId
    );
    apiClient.setRefreshToken(
        global.workanoRefreshToken[server] ||
            global.workanoRefreshToken.null ||
            apiClient.refreshToken
    );

    if (tenantId) {
        apiClient.setRefreshTenantId(tenantId);
    }

    apiClient.setRefreshDomainName(
        global.workanoRefreshDomainName[server] ||
            global.workanoRefreshDomainName.null ||
            apiClient.refreshDomainName
    );
    apiClient.setFetchOptions(
        global.workanoFetchOptions[server] ||
            global.workanoFetchOptions.null ||
            apiClient.fetchOptions
    );
    apiClient.setOnRefreshToken(
        global.workanoOnRefreshToken[server] ||
            global.workanoOnRefreshToken.null ||
            apiClient.onRefreshToken
    );
    apiClient.setOnRefreshTokenError(
        global.workanoOnRefreshTokenError[server] ||
            global.workanoOnRefreshTokenError.null ||
            apiClient.onRefreshTokenError
    );
    apiClient.setRefreshExpiration(
        global.workanoRefreshExpiration[server] ||
            global.workanoRefreshExpiration.null ||
            apiClient.refreshExpiration
    );
    apiClient.setRefreshBackend(
        global.workanoRefreshBackend[server] ||
            global.workanoRefreshBackend.null ||
            apiClient.refreshBackend
    );
    apiClient.setIsMobile(
        global.workanoIsMobile[server] ||
            global.workanoIsMobile.null ||
            apiClient.isMobile
    );

    if (requestTimeout) {
        apiClient.setRequestTimeout(requestTimeout);
    }

    return apiClient;
};

export default (
    forServer: string | null | undefined = null
): WorkanoApiClient => {
    const server: string = forServer || global.workanoCurrentServer || "";

    if (server in global.workanoClients) {
        return fillClient(global.workanoClients[server]);
    }

    global.workanoClients[server] = new WorkanoApiClient({
        server,
    });
    return fillClient(global.workanoClients[server]);
};
